import { BlockOutlined, ErrorOutlineRounded } from '@mui/icons-material';
import { Box, Button, Card, CardContent, Container, Icon, Paper, Stack, Typography } from '@mui/material';

export const ErrorBoundaryComponent = ({ error, resetErrorBoundary }) => {
    return (
        <Box
            width="100%"
            height="100vh"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            sx={{ backgroundColor: '#efefef47' }}
        >
            <Paper
                variant="outlined"
                sx={{
                    rowGap: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    p: 2,
                }}
            >
                <ErrorOutlineRounded fontSize="large" />
                <Typography variant="h5">Algo errado aconteceu</Typography>
                <Typography variant="body1">Nosso time já foi avisado</Typography>
                {(typeof error === 'string' ? error : error?.message) ? (
                    <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ maxWidth: 480, wordBreak: 'break-word', px: 1 }}
                    >
                        {typeof error === 'string' ? error : String(error.message)}
                    </Typography>
                ) : null}
                <Button variant="outlined" onClick={resetErrorBoundary}>
                    Voltar
                </Button>
            </Paper>
        </Box>
    );
};

export const EmptyContentComponent = ({ error, resfresh }) => {
    return (
        <Box sx={{ p: 4 }}>
            <Stack alignItems="center" justifyContent="center" gap={1}>
                 <BlockOutlined fontSize='large' color='disabled' />
                <Typography variant='overline' color='disabled'>Nenhum item na lista</Typography>
            </Stack>
        </Box>
    );
};
